import * as type from '../types/userVerify';
import actionCreatorFactory from 'typescript-fsa';
var actionCreator = actionCreatorFactory();
export var requestVerify = actionCreator(type.REQUEST_VERIFY);
export var successVerify = actionCreator(type.SUCCESS_VERIFY);
export var failureVerify = actionCreator(type.FAILURE_VERIFY);